

export enum PanelType {
	TOP = 'TOP',
	BOTTOM = 'BOTTOM',
	BACK = 'BACK',
	FRAME = 'FRAME',
	FILLER = 'FILLER',
	GENERIC = 'GENERIC',
	DIVIDER = 'DIVIDER',
	BASE_FRONT = 'BASE_FRONT',
	BASE_BACK = 'BASE_BACK',
	SHELF = 'SHELVE',
	FILLER_SUPPORT = 'FILLER_SUPPORT',
	FILLER_FRONT = 'FILLER_FRONT',
	FILLER_RECESSED = 'FILLER_RECESSED',
	FILLER_PANEL = 'FILLER_PANEL',
	FRONT = 'FRONT',
	DRAWER_FRONT = 'DRAWER_FRONT',
	INTERNAL_DRAWER_FRONT = 'INTERNAL_DRAWER_FRONT',
	EXTRACTABLE_SHELF = 'EXTRACTABLE_SHELF',
	EXTRACTABLE_SHELF_FRONT = 'EXTRACTABLE_SHELF_FRONT',
	INTERNAL_EXTRACTABLE_SHELF_FRONT = 'INTERNAL_EXTRACTABLE_SHELF_FRONT',
}

export enum BackPanelType {
	MOUNTED = "MOUNTED",
	FLUSH = "FLUSH",
	RECESSED = "RECESSED"
}

export enum DividerType {
	LOGICAL = 'LOGICAL',
	PANEL = 'PANEL',
}

export enum PanelGroup {
	FRAME = "FRAME",
	BACK = "BACK",
	SHELVES = "SHELVES",
	FRONT = "FRONT",
	DIVIDER = "DIVIDER",
	BASE = "BASE",
	FIXED_SHELVE = "FIXED_SHELVE",
	HANDLE_PROFILE = "HANDLE_PROFILE"
}
